import { connect } from 'react-redux';
import { ReduxStore } from '../../../store/reducers';
import { withNavBar } from '../../shared/NavBar/NavBar';
import { ObservationsForm } from '../../shared/ObservationsForm/ObservationsForm';

interface ICreateObservationsProps {
  userObject: ICognitoUser;
}

const CreateObservations = (props: ICreateObservationsProps) => {

  return (
    <>
      <ObservationsForm type="create" userEmail={props.userObject.attributes?.email} />
    </>
  );
};

const stateToProps = (state: ReduxStore) => {
  return {
    userObject: state.User.UserObject,
  };
};

export default withNavBar(connect(stateToProps)(CreateObservations), true);
